import * as React from 'react';
import { classes, style } from 'typestyle';
import { Black, Blood, Cream, Gold, Grass, GrayCream, GrayDark, Mint, Pink, White } from '../../../styles/colors';
import { mediumStyle, smallStyle } from '../../../styles/text';
export var AlertStyleType;
(function (AlertStyleType) {
    AlertStyleType["WarnA"] = "WarnA";
    AlertStyleType["WarnB"] = "WarnB";
    AlertStyleType["WarnC"] = "WarnC";
    AlertStyleType["WarnD"] = "WarnD";
    AlertStyleType["NeutralA"] = "NeutralA";
    AlertStyleType["NeutralB"] = "NeutralB";
    AlertStyleType["SuccessB"] = "SuccessB";
})(AlertStyleType || (AlertStyleType = {}));
const Alert = ({ icon, type, header, description, className }) => {
    return (React.createElement("div", { className: classes('ta-alert', containerStyle, containerTypeStyle[type], className) },
        icon && React.createElement("div", { className: iconContainerStyle }, icon),
        React.createElement("div", { className: contentContainerStyle },
            React.createElement("div", { className: headerContainerStyle }, header),
            description && React.createElement("div", { className: descriptionContainerStyle }, description))));
};
const containerStyle = style({
    display: 'flex',
    padding: '4px 12px',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: 40,
    borderRadius: 12,
});
const containerTypeStyle = {
    [AlertStyleType.WarnA]: style({
        background: Blood,
        color: White,
    }),
    [AlertStyleType.WarnB]: style({
        background: Pink,
        color: Blood,
    }),
    [AlertStyleType.WarnC]: style({
        background: Gold,
        color: White,
    }),
    [AlertStyleType.NeutralA]: style({
        background: GrayDark,
        color: White,
    }),
    [AlertStyleType.NeutralB]: style({
        background: GrayCream,
        color: Black,
    }),
    [AlertStyleType.SuccessB]: style({
        background: Mint,
        color: Grass,
    }),
    [AlertStyleType.WarnD]: style({
        background: Cream,
        color: Gold,
    }),
};
const iconContainerStyle = style({
    marginTop: 4,
    marginRight: 8,
});
const contentContainerStyle = style({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
});
const headerContainerStyle = mediumStyle;
const descriptionContainerStyle = classes(smallStyle, style({
    marginTop: 2,
}));
export default Alert;
//# sourceMappingURL=Alert.js.map